import { render, staticRenderFns } from "./SmsCenter.vue?vue&type=template&id=187bb845&scoped=true&"
import script from "./SmsCenter.vue?vue&type=script&lang=js&"
export * from "./SmsCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187bb845",
  null
  
)

export default component.exports